/**
 * Components - Slider
 * Establishing a working library in order to attach the Splide slider
 * JavaScript library wherever needed. Splide controls, structure and other
 * documentation can be found at https://splidejs.com/guides/getting-started/
 *
 * - 01 - Globals
 * - 02 - Splide
 */

/*------------------------------------*
  01 - Globals
  Declared functions here will be used throughout the rest of this JavaScript
  document, throughout each declared behavior.
\*------------------------------------*/
((Drupal, once, Splide) => {
  const { bindPaginationButtons } = window.OhanaTabbedGalleryHelpers || {};

  Splide.defaults = {
    i18n: {
      prev: 'Previous slide',
      next: 'Next slide',
    },
  };

  /*------------------------------------*\
  02 - Splide
  Taking the external Splide NPM package library and using it to instantiate
  instances wherever necessary, with addition logic and functionality also
  attached.
\*------------------------------------*/
  function initializePagination(givenElement, primarySlider, secondarySlider) {
    const paginationWrapper = givenElement.querySelector('.splide__pagination');

    if (!paginationWrapper || !bindPaginationButtons) {
      return;
    }

    bindPaginationButtons({
      paginationButtons: Array.from(paginationWrapper.querySelectorAll('.splide__pagination__page')),
      primarySlider,
      secondarySlider,
    });
  }

  Drupal.behaviors.slideshowMedia = {
    /**
     * Slider
     * Mounting function for synchronized Splide sliders
     * @param givenElement: [object] Slider wrapper to act upon.
     */
    slider(givenElement) {
      const mainSlider = givenElement.querySelector('.splide--main');
      const thumbnailSlider = givenElement.querySelector('.splide--thumbnail');
      const staticContent = givenElement.querySelector('.c-tabbed-gallery__static');

      // If there's static content, only initialize the thumbnail slider
      if (staticContent) {
        if (!thumbnailSlider) {
          console.warn('Thumbnail slider not found for static content.');
          return;
        }

        const thumbTrack = thumbnailSlider.querySelector('.splide__track .splide__list');
        if (!thumbTrack || thumbTrack.children.length === 0) {
          console.warn('No slides found in thumbnail slider.');
          return;
        }

        // Initialize only thumbnail slider for static content
        const thumbnails = new Splide(thumbnailSlider, {
          rewind: true,
          pagination: false,
          arrows: true,
          focus: 'center',
          trimSpace: false,
        });

        thumbnails.mount();

        // Set up custom pagination for static content.
        initializePagination(givenElement, thumbnails);
        
        console.log('Static content slider initialized');
        return;
      }

      // Check if both sliders exist and have the required structure
      if (!mainSlider || !thumbnailSlider) {
        return;
      }

      const mainTrack = mainSlider.querySelector('.splide__track .splide__list');
      const thumbTrack = thumbnailSlider.querySelector('.splide__track .splide__list');

      if (!mainTrack || !thumbTrack) {
        return;
      }

      // Check if there are slides
      if (mainTrack.children.length === 0 || thumbTrack.children.length === 0) {
        return;
      }

      // Initialize main slider (images)
      const main = new Splide(mainSlider, {
        type: 'slide',
        rewind: true,
        pagination: false,
        arrows: false,
        autoHeight: true,
      });

      // Initialize thumbnail slider (content)
      const thumbnails = new Splide(thumbnailSlider, {
        rewind: true,
        pagination: false,
        arrows: true,
        focus: 'center',
        trimSpace: false,
        autoHeight: true,
      });

      // Sync the sliders
      main.sync(thumbnails);

      // Mount both sliders.
      main.mount();
      thumbnails.mount();

      // Set up real button-based navigation for the gallery.
      initializePagination(givenElement, main, thumbnails);

    },

    /*
     * Attach
     * Final build to the site for display within Drupal context.
     * - @param context: Website document context.
     */

    attach(context) {
      once('slideshowMedia', '.c-tabbed-gallery', context).forEach((slider) => {
        if (slider.length === 0) {
          return;
        }
        this.slider(slider);
      });
    },
  };
})(Drupal, once, Splide);